module.exports = __webpack_public_path__ + "img/LaunchGrader_logo.690a1942.png";